import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { CallHistoryRes } from "../../types/CallHistoryRes";

export const useCallHistory = () => {
  return useQuery<CallHistoryRes, Error>(
    ["chat/call-history"],
    async () => {
      const response = await axiosInstance.post<CallHistoryRes>("chat/call-history", {});
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};
